import { useEffect, useState } from 'react';
import { getToken } from '../services/storage';

const cache = new Map<string, string>();

function hasSasToken(url: string): boolean {
  try {
    return new URL(url).searchParams.has('sig');
  } catch {
    return false;
  }
}

async function loadImage(url: string): Promise<string> {
  // URLs de Azure Blob con SAS token: cargar directamente, sin auth header
  if (hasSasToken(url)) return url;

  // Resto: fetch con Bearer token
  const token = getToken();
  if (!token) return url;
  try {
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return '';
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch {
    return '';
  }
}

export function useAuthImage(url: string | undefined): string {
  const [src, setSrc] = useState<string>(() =>
    url && cache.has(url) ? cache.get(url)! : ''
  );

  useEffect(() => {
    if (!url) return;
    if (cache.has(url)) { setSrc(cache.get(url)!); return; }

    loadImage(url).then((result) => {
      if (result) cache.set(url, result);
      setSrc(result);
    });
  }, [url]);

  return src;
}
